<template>
  <div class="p-4">
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-6 text-left">
              <h4>Forms download</h4>
          </div>
          <div class="col-6 text-right">
            <appModalFormsDownloadNew></appModalFormsDownloadNew>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="table-responsive table-sm">
          <!-- Datatable -->
          <DataTable
            :header-fields="headerFields"
            :sort-field="sortField"
            :sort="sort"
            :data="data || []"
            :is-loading="isLoading"
            :css="datatableCss"
            not-found-msg="Items not found"
            @on-update="dtUpdateSort"
            track-by="firstName"
          >
            <!-- Action button slot -->
            <template v-slot:actions="props">
              <appModalFormsDownloadEdit :propsData="props" class="d-inline"></appModalFormsDownloadEdit>
            </template>

            <!--
              Pagination component as a slot, but could be drag out from Database element
            -->
            <template v-slot:pagination>
              <Pagination
                :page="currentPage"
                :total-items="totalItems"
                :items-per-page="itemsPerPage"
                :css="paginationCss"
                @on-update="changePage"
                @update-current-page="updateCurrentPage"
              />
            </template>

            <!--
              ItemsPerPage component as a slot, but could be drag out from Database element
            -->
            <div class="items-per-page" slot="ItemsPerPage">
              <label>Items per page</label>
              <ItemsPerPageDropdown
                :list-items-per-page="listItemsPerPage"
                :items-per-page="itemsPerPage"
                :css="itemsPerPageCss"
                @on-update="updateItemsPerPage"
              />
            </div>

            <!-- Spinner element as slot used when is-loading attribute is true -->
            <Spinner slot="spinner"/>

             <!-- Custom element for Primary -->
             

            <div slot="custUrl" slot-scope="props">
              <div v-if="props.rowData.url">
                <span class="badge badge-primary"  style="cursor: pointer"   @click="fnOpenDocument(props)">Document</span>
              </div>
              <div v-else>
                 <span></span>
              </div>
            </div>


            <div slot="custStatus" slot-scope="props">
              <div v-if="props.rowData.status == 1">
                <span class="badge badge-success">Active</span>
              </div>
              <div v-else>
                 <span class="badge badge-danger">In-active</span>
              </div>
            </div>
            <div slot="custOther1" slot-scope="props">
              <div v-if="props.rowData.other1 != null">
                <span>{{ props.rowData.other1 }}</span>
              </div>
            </div>
            <div slot="custOther2" slot-scope="props">
              <div v-if="props.rowData.other2 != null">
                <span>{{ props.rowData.other2 }}</span>
              </div>
            </div>


            <div slot="custCreatedBy" slot-scope="props">
              <div v-if="props.rowData.created_user">
                <span class="text-capitalize">{{ props.rowData.created_user.firstName }}</span>
              </div>
            </div>

            <div slot="custEditedBy" slot-scope="props">
              <div v-if="props.rowData.edited_user">
                <span class="text-capitalize">{{ props.rowData.edited_user.firstName }}</span>
              </div>
            </div>
          </DataTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../../store/modules/base.module';
import Spinner from "vue-simple-spinner";
import { DataTable, ItemsPerPageDropdown, Pagination } from "v-datatable-light";
import orderBy from "lodash.orderby";
import { mapGetters, mapActions } from 'vuex';
import appModalFormsDownloadNew from '../../../components/settings/ModalFormsDownloadNew.vue';
import appModalFormsDownloadEdit from '../../../components/settings/ModalFormsDownloadEdit.vue';


const addZero = value => ("0" + value).slice(-2);
const formatDate = value => {
  if (value) {
    const dt = new Date(value);
    return `${addZero(dt.getDate())}/${addZero(
      dt.getMonth() + 1
    )}/${dt.getFullYear()}`;
  }
  return "";
};


export default {
  name:'visaTypeList',
    components: {
       	DataTable,
        ItemsPerPageDropdown,
        Pagination,
        Spinner,
        appModalFormsDownloadNew,
        appModalFormsDownloadEdit,
    },

  data: function() {
    return {
      initialData:'',
      data:'',
      headerFields: [
        {
          name: "form_title",
          label: "Form title",
        },
        {
          name: "provider",
          label: "Provider",
        },
        {
          name: "other1",
          label: "Sub title 1",
          customElement: "custOther1",
        },
        {
          name: "other2",
          label: "Sub title 2",
          customElement: "custOther2",
        },
        {
          name: "url",
          label: "Document",
          customElement: "custUrl",
        },
        {
          name: "status",
          label: "Status",
          sortable: true,
          customElement: "custStatus",
        },
        {
          name: "createdBy",
          label: "Created By",
          sortable: true,
          customElement: "custCreatedBy",
        },
        {
          name: "editedBy",
          label: "Edited By",
          sortable: true,
          customElement: "custEditedBy",
        },
        {
          name: "created_at",
          label: "Created",
          sortable: true,
          format:formatDate
        },
        {
          name: "updated_at",
          label: "Updated",
          sortable: true,
          format:formatDate
        },
        "__slot:actions"
      ],

      datatableCss: {
        table: "table table-bordered table-hover table-striped table-center",
        theadTh: "header-item",
        thWrapper: "th-wrapper",
        thWrapperCheckboxes: "th-wrapper checkboxes",
        arrowsWrapper: "arrows-wrapper",
        arrowUp: "arrow up",
        arrowDown: "arrow down",
        footer: "footer"
      },
      paginationCss: {
        paginationItem: "pagination-item",
        moveFirstPage: "move-first-page",
        movePreviousPage: "move-previous-page",
        moveNextPage: "move-next-page",
        moveLastPage: "move-last-page",
        pageBtn: "page-btn"
      },
      itemsPerPageCss: {
        select: "item-per-page-dropdown"
      },
      isLoading: false,
      sort: "asc",
      sortField: "firstName",
      listItemsPerPage: [5, 10, 20, 50, 100],
      itemsPerPage: 10,
      currentPage: 1,
      totalItems: 160,
      hometown: null,
      createHeaderName: "created:header"
    };
  },

  computed:{
      ...mapGetters([
        'gettFormDownloadAll'
      ]),
  },
  methods: {
    ...mapActions([
       'fetchFormDownloadAll'
    ]),

    fnOpenDocument(props){
      window.open(`${props.rowData.url}`, '_blank');
    },

    dtUpdateSort: function({ sortField, sort }) {
      const sortedData = orderBy(this.initialData, [sortField], [sort]);
      const start = (this.currentPage - 1) * Number(this.itemsPerPage);
      const end = this.currentPage *  Number(this.itemsPerPage);
      this.data = sortedData.slice(start, end);
    },

    updateItemsPerPage: function(itemsPerPage) {
      this.itemsPerPage = Number(itemsPerPage);
      if (Number(itemsPerPage) >= this.initialData.length) {
        this.data = this.initialData;
      } else {
        this.data = this.initialData.slice(0, Number(itemsPerPage));
      }
    },

    changePage: function(currentPage) {
      this.currentPage = currentPage;
      const start = (currentPage - 1) * Number(this.itemsPerPage);
      const end = currentPage * Number(this.itemsPerPage);
      this.data = this.initialData.slice(start, end);
    },

    updateCurrentPage: function(currentPage) {
      this.currentPage = currentPage;
    },
  },
  created(){
    this.fetchFormDownloadAll();
  },
  watch:{
      gettFormDownloadAll:function(val){
        this.totalItems = val.length;
        this.initialData = val;
        this.data = val.slice(0, 10);
      },
  },
}
</script>